import { useParams } from "react-router-dom";
import { legalServicesData } from "../../../data/legalServicesData";

import HeroSection from "./LegalServicesDetail/HeroSection";
import FeaturesSection from "./LegalServicesDetail/FeaturesSection";
import BenefitsSection from "./LegalServicesDetail/BenefitsSection";
import DocumentsSection from "./LegalServicesDetail/DocumentsSection";
import ProcessSection from "./LegalServicesDetail/ProcessSection";
import FAQSection from "./LegalServicesDetail/FAQSection";
import CTASection from "./LegalServicesDetail/CTASection";

const LegalServicesDetail = () => {
  const { slug } = useParams();

  const service = legalServicesData.find(
    (item) => item.slug === slug
  );

  if (!service) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#050505]">
        <h1 className="text-4xl font-bold text-white">
          Service Not Found
        </h1>
      </div>
    );
  }

  return (
    <main className="bg-[#050505] font-saira">
      <HeroSection data={service.hero} />

      <FeaturesSection data={service.features} />

      <BenefitsSection data={service.benefits} />

      <DocumentsSection data={service.documents} />

      <ProcessSection data={service.process} />

      <FAQSection data={service.faqs} />

      <CTASection data={service.cta} />
    </main>
  );
};

export default LegalServicesDetail;